import Star from '@mui/icons-material/Star';
import { makeObservable, observable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroDestaques extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    get label() {
        return 'Com manifestação (destaque de magistrado)';
    }

    getIconeFiltroRapido() {
        return <Star />;
    }

    filtroRapido = {
        valor: true
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            filtroRapido: observable
        });
    }

    getValorOpcao(registro) {
        return (
            registro.contabilizacoesObservacao &&
            registro.contabilizacoesObservacao.findIndex(
                (observacao) => observacao.tipoObservacao === 'DESTAQUE' && observacao.visibilidade === 'PUBLICA'
            ) !== -1
        );
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }
}
